import { observer } from 'mobx-react-lite'
import { Alert, TextareaWithLabel } from 'shared/ui'
import { type TransferConversationModalStore } from '../store/transferConversationModalStore'

import styles from './styles.module.scss'
import { OrganizationsDropdown } from './OrganizationsDropdown/OrganizationsDropdown'
import { InboxesDropdown } from './InboxesDropdown/InboxesDropdown'
import { MembersDropdown } from './MembersDropdown/MembersDropdown'

export const TransferConversationModalContent = observer(
  ({ store }: { store: TransferConversationModalStore }) => {
    const { note, setNote, isSingleOrganization, noteError } = store

    return (
      <div className={styles.wrap}>
        <Alert
          item={{
            desc: 'Your contact will see 2 separate conversations on their device.',
            type: 'infoLight',
          }}
        />
        <div className={styles.content}>
          {!isSingleOrganization && <OrganizationsDropdown store={store} />}
          <InboxesDropdown store={store} />
          <MembersDropdown store={store} />
          <TextareaWithLabel
            labelProps={{ label: { text: 'Add a note (Optional)' } }}
            value={note}
            errorType='bottomText'
            error={noteError}
            rows={6}
            name='description'
            placeholder='Your text'
            onChange={setNote}
          />
        </div>
      </div>
    )
  }
)
